<wp-embedded-table #embeddedTableForConfiguration
                   [queryProps]="queryProps"
                   [configuration]="{ tableVisible: false }" />
